import { state, currentUserRole, statusInterval, setStatusInterval } from '../state';
import { apiCall } from '../api';
import { showToast, showLoader, hideLoader, dualListGetValues, formatFileLabel } from '../utils';
import { createVirtualTable, loadGroups, getDisplayColumnName, dualListInit, getMassColumns, DEFAULT_MASS_COLUMNS, currentMassColumns, updateMassGroupsToggleText } from './common';
import { loadAdminAttrEditor } from './admin';
import { renderStrategyEditor, saveCurrentStrategy, resetGroupStrategy, resetAllStrategies, loadDefaultStrategiesAndApply } from './strategies';

function getEl<T extends HTMLElement>(id: string): T | null { return document.getElementById(id) as T | null; }
function getInput(id: string): HTMLInputElement | null { return getEl<HTMLInputElement>(id); }
function getSelect(id: string): HTMLSelectElement | null { return getEl<HTMLSelectElement>(id); }
function getButton(id: string): HTMLButtonElement | null { return getEl<HTMLButtonElement>(id); }
const Tabulator = (window as any).Tabulator;

    // -------------------- СПРАВОЧНИК --------------------
    async function startPollingStatus() {
        if (statusInterval) clearInterval(statusInterval);
        const statusDiv = getEl<HTMLElement>('ref-update-status')!;
        const messageDiv = getEl<HTMLElement>('ref-status-message')!;
        const progressBar = getEl<HTMLProgressElement>('ref-status-progress')!;
        statusDiv.style.display = 'block';
        setStatusInterval(setInterval(async () => {
            const res = await fetch('/api/reference/status');
            const status = await res.json();
            messageDiv.innerText = status.message || 'Обработка...';
            if (status.total > 0) {
                const percent = (status.progress / status.total) * 100;
                progressBar.value = percent;
            }
            if (!status.running) {
                clearInterval(statusInterval);
                setStatusInterval(null);
                if (status.error) {
                    messageDiv.className = 'status error';
                    messageDiv.innerText = 'Ошибка: ' + status.error;
                } else {
                    messageDiv.className = 'status success';
                    messageDiv.innerText = 'Обновление завершено!';
                    setTimeout(() => statusDiv.style.display = 'none', 30000);
                    await loadGroups();
                }
            }
        }, 10000));
    }

    getButton('ref-open-editor')!.onclick = () => {
        const group = getSelect('ref-group-select')!.value;
        if (!group) {
            showToast('Выберите группу', 'error');
            return;
        }
        state.tableEditor.open({ source: 'ref', group, title: 'Редактор справочника' });
    };


    getButton('ref-reprocess')!.onclick = async () => {
        if (currentUserRole !== 'admin') {
            showToast('Недостаточно прав', 'error');
            return;
        }
        openRefReprocessModal();
    };

    async function openRefReprocessModal(): Promise<void>{
        const modal = getEl<HTMLElement>('ref-reprocess-modal')!;
        modal.style.display = 'flex';
        const select = getSelect('ref-reprocess-file-select')!;
        select.innerHTML = '<option value="">-- выберите файл --</option>';
        getEl<HTMLElement>('ref-reprocess-groups-container')!.style.display = 'none';
        getEl<HTMLElement>('ref-reprocess-no-groups')!.style.display = 'none';
        getButton('ref-reprocess-btn')!.disabled = true;
        
        const data = await apiCall('/api/reference/files', 'GET');
        if (!data || !data.files || data.files.length === 0) {
            select.innerHTML = '<option value="">Нет загруженных файлов</option>';
            return;
        }
        state.reprocessFiles = data.files;
        data.files.forEach(f => {
            const opt = document.createElement('option');
            opt.value = f.file_id;
            opt.textContent = formatFileLabel(f.filename || f.file_id, f.created_at || f.processed_date);
            select.appendChild(opt);
        });
        select.onchange = onReprocessFileChange;
    }
(window as any).openRefReprocessModal = openRefReprocessModal;

    function closeRefReprocessModal(): void{
        getEl<HTMLElement>('ref-reprocess-modal')!.style.display = 'none';
        getSelect('ref-reprocess-file-select')!.innerHTML = '';
        getEl<HTMLElement>('ref-reprocess-groups-list')!.innerHTML = '';
        state.reprocessFiles = [];
    }
(window as any).closeRefReprocessModal = closeRefReprocessModal;

    async function onReprocessFileChange() {
        const fileId = getSelect('ref-reprocess-file-select')!.value;
        const container = getEl<HTMLElement>('ref-reprocess-groups-container')!;
        const noGroups = getEl<HTMLElement>('ref-reprocess-no-groups')!;
        const btn = getButton('ref-reprocess-btn')!;
        const list = getEl<HTMLElement>('ref-reprocess-groups-list')!;
        list.innerHTML = '';
        
        if (!fileId) {
            container.style.display = 'none';
            noGroups.style.display = 'none';
            btn.disabled = true;
            return;
        }
        
        const data = await apiCall(`/api/reference/file/${fileId}/groups`, 'GET');
        if (!data || !data.groups || data.groups.length === 0) {
            container.style.display = 'none';
            noGroups.style.display = 'block';
            btn.disabled = true;
            return;
        }
        
        data.groups.forEach(g => {
            const div = document.createElement('div');
            div.style.display = 'flex';
            div.style.alignItems = 'center';
            div.style.gap = '8px';
            const dateStr = g.processed_date ? new Date(g.processed_date).toLocaleString() : 'не обрабатывалась';
            div.innerHTML = `
                <input type="checkbox" class="ref-reprocess-group-cb" value="${g.group.replace(/"/g, '&quot;')}" checked style="width:18px; height:18px;">
                <span style="flex:1;">${g.group}</span>
                <span style="color:#666; font-size:12px;">${dateStr}</span>
            `;
            list.appendChild(div);
        });
        
        container.style.display = 'block';
        noGroups.style.display = 'none';
        btn.disabled = false;
    }

    async function confirmRefReprocess(): Promise<void>{
        const fileId = getSelect('ref-reprocess-file-select')!.value;
        if (!fileId) return;
        
        const checkboxes = document.querySelectorAll<HTMLInputElement>('.ref-reprocess-group-cb');
        const selectedGroups = [];
        checkboxes.forEach(cb => {
            if (cb.checked) selectedGroups.push(cb.value);
        });
        
        // skip_groups = те, что НЕ выбраны
        const allGroups = Array.from(checkboxes).map(cb => cb.value);
        const skipGroups = allGroups.filter(g => !selectedGroups.includes(g));
        
        const mode = document.querySelector<HTMLInputElement>('input[name=\"ref-reprocess-mode\"]:checked').value;
        
        closeRefReprocessModal();
        showLoader('Запуск переобработки...');
        const token = localStorage.getItem('token');
        const res = await fetch('/api/reference/update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            },
            body: JSON.stringify({ file_id: fileId, skip_groups: skipGroups, mode: mode })
        });
        hideLoader();
        const data = await res.json();
        if (data.success) {
            startPollingStatus();
        } else {
            showToast(data.message, 'error');
        }
    }
(window as any).confirmRefReprocess = confirmRefReprocess;

    export async function loadReferenceFiles() {
        const data = await apiCall('/api/reference/files', 'GET');
        const container = getEl<HTMLElement>('ref-files-list')!;
        const btn = getButton('ref-set-active-btn')!;
        if (!data || !data.files) {
            container.innerHTML = '<div class="warning">Нет загруженных файлов</div>';
            btn.style.display = 'none';
            return;
        }
        const activeSet = new Set(data.active || []);
        let html = '<table class="ref-table"><thead><tr><th>Файл</th><th>Группы</th><th>Строк</th><th>Дата</th>';
        if (currentUserRole === 'admin') {
            html += '<th>Активен</th><th>Действия</th>';
        }
        html += '</tr></thead><tbody>';
        data.files.forEach(f => {
            const isActive = activeSet.has(f.file_id);
            html += `<tr>
                <td>${formatFileLabel(f.filename, f.created_at || f.processed_date)}</td>
                <td>${(f.groups || []).join(', ')}</td>
                <td>${f.total_rows}</td>
                <td>${f.processed_date ? new Date(f.processed_date).toLocaleString() : ''}</td>`;
            if (currentUserRole === 'admin') {
                html += `<td><input type="checkbox" class="ref-active-cb" data-file-id="${f.file_id}" ${isActive ? 'checked' : ''}></td>`;
                html += `<td>
                    <button data-action="editRefFile" data-file-id="${f.file_id}" data-filename="${f.filename.replace(/"/g, '&quot;')}" title="Редактировать">✏️</button>
                    <button data-action="resyncRefFile" data-file-id="${f.file_id}" data-filename="${f.filename.replace(/"/g, '&quot;')}" title="Пересчитать системные колонки без полной переобработки">🔄</button>
                    <button data-action="openRefResyncModal" data-file-id="${f.file_id}" data-filename="${f.filename.replace(/"/g, '&quot;')}" title="Изменить привязку колонок и пересчитать">⚙️</button>
                    <button data-action="deleteRefFile" data-file-id="${f.file_id}" class="danger" title="Удалить">🗑️</button>
                </td>`;
            }
            html += '</tr>';
        });
        html += '</tbody></table>';
        container.innerHTML = html;
        btn.style.display = currentUserRole === 'admin' ? 'inline-block' : 'none';
        // Показываем настройки колонок только админу
        getEl<HTMLElement>('ref-column-settings-card')!.style.display = currentUserRole === 'admin' ? 'block' : 'none';
    }

    async function deleteRefFile(fileId: string): Promise<void>{
        if (!confirm('Удалить файл из справочника? Это действие нельзя отменить.')) return;
        const res = await apiCall('/api/reference/delete_file', 'POST', { file_id: fileId });
        if (res && res.success) {
            showToast('Файл удалён', 'success');
            await loadReferenceFiles();
            await loadGroups();
        }
    }
(window as any).deleteRefFile = deleteRefFile;

    async function resyncRefFile(fileId: string, filename: string | null): Promise<void>{
        const msg = filename
            ? `Пересчитать системные колонки для файла "${filename}"?\n\nЭто обновит qty, price, warehouse, territory, source_id из исходного raw-файла без полной переобработки (classification / parsing).`
            : 'Пересчитать системные колонки для этого файла?';
        if (!confirm(msg)) return;
        showLoader('Пересчёт системных колонок...');
        const res = await apiCall(`/api/reference/${fileId}/resync_columns`, 'POST', {});
        hideLoader();
        if (res && res.success) {
            showToast(`Обновлено записей: ${res.records_updated || 0}`, 'success');
            await loadReferenceFiles();
            await loadGroups();
        } else if (res && res.error && res.error.includes('column_mapping')) {
            // Если mapping не сохранён — предлагаем настроить колонки
            showToast('Привязка колонок не настроена. Открываю окно настройки...', 'warning');
            await openRefResyncModal(fileId, filename);
        } else {
            showToast(res?.error || 'Ошибка при resync', 'error');
        }
    }
(window as any).resyncRefFile = resyncRefFile;

    async function openRefResyncModal(fileId: string, filename: string | null): Promise<void>{
        state.currentResyncFileId = fileId;
        getEl<HTMLElement>('ref-resync-title')!.innerText = `Настройка колонок: ${filename}`;
        showLoader('Загрузка колонок файла...');
        const res = await apiCall(`/api/reference/file_columns/${fileId}`, 'GET');
        hideLoader();
        if (!res || !res.columns) {
            showToast('Не удалось загрузить колонки файла', 'error');
            return;
        }
        const cols = res.columns;
        const mapping = res.column_mapping || {};
        state.currentResyncMapping = mapping;
        state.currentResyncHeaderRow = res.header_row;
        const setOpts = (id: string, val: any) => {
            const sel = getSelect(id); if (!sel) return;
            sel.innerHTML = '<option value="">-- нет --</option>' + cols.map(c => `<option value="${c}" ${val === c ? 'selected' : ''}>${c}</option>`).join('');
        };
        setOpts('ref-resync-qty', mapping.qty_column || '');
        setOpts('ref-resync-unit', mapping.qty_unit_column || '');
        setOpts('ref-resync-price', mapping.price_column || '');
        setOpts('ref-resync-wh', mapping.warehouse_column || '');
        setOpts('ref-resync-territory', mapping.territory_column || '');
        setOpts('ref-resync-id', mapping.id_column || '');
        setOpts('ref-resync-contract', mapping.contract_no_column || '');
        setOpts('ref-resync-contractpos', mapping.contract_pos_column || '');
        getEl<HTMLElement>('ref-resync-modal')!.style.display = 'flex';
    }
(window as any).openRefResyncModal = openRefResyncModal;

    function closeRefResyncModal(): void{
        getEl<HTMLElement>('ref-resync-modal')!.style.display = 'none';
        state.currentResyncFileId = null;
    }
(window as any).closeRefResyncModal = closeRefResyncModal;

    async function confirmRefResync(): Promise<void>{
        const fileId = state.currentResyncFileId;
        if (!fileId) return;
        const columnMapping: Record<string, any> = {
            qty_column: getSelect('ref-resync-qty')!.value || null,
            qty_unit_column: getSelect('ref-resync-unit')!.value || null,
            price_column: getSelect('ref-resync-price')!.value || null,
            warehouse_column: getSelect('ref-resync-wh')!.value || null,
            territory_column: getSelect('ref-resync-territory')!.value || null,
            id_column: getSelect('ref-resync-id')!.value || null,
            contract_no_column: getSelect('ref-resync-contract')!.value || null,
            contract_pos_column: getSelect('ref-resync-contractpos')!.value || null,
        };
        // Сохраняем title_columns и header_row из исходного mapping, чтобы title_hash совпадал
        const savedMapping = state.currentResyncMapping || {};
        if (savedMapping.title_columns) {
            columnMapping.title_columns = savedMapping.title_columns;
        }
        if (state.currentResyncHeaderRow !== undefined && state.currentResyncHeaderRow !== null) {
            columnMapping.header_row = state.currentResyncHeaderRow;
        }
        if (savedMapping.sheet_names) {
            columnMapping.sheet_names = savedMapping.sheet_names;
        } else if (savedMapping.sheet_name) {
            columnMapping.sheet_name = savedMapping.sheet_name;
        }
        showLoader('Пересчёт системных колонок...');
        const res = await apiCall(`/api/reference/${fileId}/resync_columns`, 'POST', { column_mapping: columnMapping });
        hideLoader();
        closeRefResyncModal();
        if (res && res.success) {
            showToast(`Обновлено записей: ${res.records_updated || 0}`, 'success');
            await loadReferenceFiles();
            await loadGroups();
        } else {
            showToast(res?.error || 'Ошибка при resync', 'error');
        }
    }
(window as any).confirmRefResync = confirmRefResync;

    async function editRefFile(fileId: string, filename: string | null): Promise<void>{
        const res = await apiCall(`/api/reference/file_raw/${fileId}`, 'GET');
        if (!res || !res.data) {
            showToast('Не удалось загрузить файл', 'error');
            return;
        }
        state.currentEditFileId = fileId;
        state.currentEditFileData = res.data;
        getEl<HTMLElement>('ref-file-edit-title')!.innerText = `Редактирование: ${filename}`;
        const modal = getEl<HTMLElement>('ref-file-edit-modal')!;
        modal.style.display = 'flex';
        const cols = res.columns || Object.keys(res.data[0] || {});
        await createVirtualTable('ref-file-edit-table', res.data, cols, { editable: true });
    }
(window as any).editRefFile = editRefFile;

    function closeRefFileEditModal(): void{
        getEl<HTMLElement>('ref-file-edit-modal')!.style.display = 'none';
        state.currentEditFileId = null;
        state.currentEditFileData = null;
    }
(window as any).closeRefFileEditModal = closeRefFileEditModal;

    async function saveRefFileEdits(): Promise<void>{
        if (!state.currentEditFileId) return;
        const table = Tabulator.findTable('#ref-file-edit-table')[0];
        if (!table) return;
        const newData = table.getData();
        showLoader('Сохранение и переобработка...');
        const res = await apiCall(`/api/reference/file_raw/${state.currentEditFileId}/save`, 'POST', { data: newData });
        hideLoader();
        if (res && res.success) {
            showToast('Файл сохранён и переобработан', 'success');
            closeRefFileEditModal();
            await loadReferenceFiles();
            await loadGroups();
            startPollingStatus();
        }
    }
(window as any).saveRefFileEdits = saveRefFileEdits;

    function toggleRefColumnsPanel(): void{
        const panel = getEl<HTMLElement>('ref-file-edit-columns-panel')!;
        if (panel.style.display === 'none' || !panel.style.display) {
            panel.style.display = 'block';
            renderRefColumnList();
        } else {
            panel.style.display = 'none';
        }
    }
(window as any).toggleRefColumnsPanel = toggleRefColumnsPanel;

    function renderRefColumnList() {
        const table = Tabulator.findTable('#ref-file-edit-table')[0];
        if (!table) return;
        const cols = table.getColumns().map(c => c.getField()).filter(c => c);
        const container = getEl<HTMLElement>('ref-file-edit-column-list')!;
        let html = '';
        cols.forEach(col => {
            html += `<div style="display:flex; align-items:center; gap:6px; background:white; padding:4px 8px; border-radius:4px; border:1px solid #ddd;">
                <input type="text" data-old-name="${col}" value="${col}" style="width:140px; font-size:12px; padding:2px 6px;">
                <button data-action="removeRefColumn" data-col="${col.replace(/"/g, '&quot;')}" class="danger" style="padding:2px 8px; font-size:11px;">✕</button>
            </div>`;
        });
        container.innerHTML = html;
    }

    function removeRefColumn(colName: string): void{
        const table = Tabulator.findTable('#ref-file-edit-table')[0];
        if (!table) return;
        if (!confirm(`Удалить колонку "${colName}"?`)) return;
        const data = table.getData();
        data.forEach(row => delete row[colName]);
        const cols = table.getColumns().map(c => c.getField()).filter(c => c && c !== colName);
        // Пересоздаем таблицу
        getEl<HTMLElement>('ref-file-edit-table')!.innerHTML = '';
        new Tabulator('#ref-file-edit-table', {
            data: data,
            layout: "fitColumns",
            virtualDom: true,
            pagination: "local",
            paginationSize: 50,
            movableColumns: true,
            columns: cols.map(c => ({ title: c, field: c, editor: "input", headerFilter: "input" }))
        });
        renderRefColumnList();
    }
(window as any).removeRefColumn = removeRefColumn;

    function applyRefColumnChanges(): void{
        const table = Tabulator.findTable('#ref-file-edit-table')[0];
        if (!table) return;
        const inputs = document.querySelectorAll<HTMLInputElement>('#ref-file-edit-column-list input[data-old-name]');
        let data = table.getData();
        let hasChanges = false;
        const renameMap: Record<string, any> = {};
        inputs.forEach(inp => {
            const oldName = inp.dataset.oldName;
            const newName = inp.value.trim();
            if (newName && newName !== oldName) {
                renameMap[oldName] = newName;
                hasChanges = true;
            }
        });
        if (!hasChanges) {
            getEl<HTMLElement>('ref-file-edit-columns-panel')!.style.display = 'none';
            return;
        }
        // Применяем переименования к данным
        data = data.map(row => {
            const newRow: Record<string, any> = {};
            for (const [k, v] of Object.entries(row)) {
                newRow[renameMap[k] || k] = v;
            }
            return newRow;
        });
        const newCols = Object.keys(data[0] || {});
        // Пересоздаем таблицу
        getEl<HTMLElement>('ref-file-edit-table')!.innerHTML = '';
        new Tabulator('#ref-file-edit-table', {
            data: data,
            layout: "fitColumns",
            virtualDom: true,
            pagination: "local",
            paginationSize: 50,
            movableColumns: true,
            columns: newCols.map(c => ({ title: c, field: c, editor: "input", headerFilter: "input" }))
        });
        getEl<HTMLElement>('ref-file-edit-columns-panel')!.style.display = 'none';
        showToast('Колонки обновлены', 'success');
    }
(window as any).applyRefColumnChanges = applyRefColumnChanges;

    function cancelRefColumnChanges(): void{
        getEl<HTMLElement>('ref-file-edit-columns-panel')!.style.display = 'none';
    }
(window as any).cancelRefColumnChanges = cancelRefColumnChanges;

    // ---------- НАСТРОЙКА ОТОБРАЖАЕМЫХ КОЛОНОК ----------
    export async function loadColumnSettings() {
        const res = await apiCall('/api/reference/column_settings', 'GET');
        if (res && res.settings) {
            state.columnSettings = res.settings;
        }
    }

    async function loadRefColumnCheckboxes() {
        const res = await apiCall('/api/reference/raw_columns', 'GET');
        const container = getEl<HTMLElement>('ref-column-checkboxes')!;
        if (!res || !res.columns || !res.columns.length) {
            container.innerHTML = '<div class="warning">Нет загруженных справочников или колонки не определены</div>';
            return;
        }
        const selected = new Set(state.columnSettings || []);
        let html = '';
        res.columns.forEach(col => {
            const checked = selected.has(col) ? 'checked' : '';
            html += `<label style="display:flex; align-items:center; gap:6px; cursor:pointer; background:#f8f9fa; padding:6px 12px; border-radius:20px; border:1px solid #e0e0e0; flex-shrink:0; white-space:nowrap;">
                <input type="checkbox" value="${col}" ${checked}> ${getDisplayColumnName(col)}
            </label>`;
        });
        container.innerHTML = html;
    }

    async function saveColumnSettings() {
        const checkboxes = document.querySelectorAll<HTMLInputElement>('#ref-column-checkboxes input[type=\"checkbox\"]:checked');
        const selected = Array.from(checkboxes).map(cb => cb.value);
        state.columnSettings = selected;
        await apiCall('/api/reference/column_settings', 'POST', { settings: state.columnSettings });
        showToast('Настройки колонок сохранены', 'success');
    }

    async function resetColumnSettings() {
        state.columnSettings = [];
        await apiCall('/api/reference/column_settings', 'POST', { settings: state.columnSettings });
        await loadRefColumnCheckboxes();
        showToast('Настройки сброшены. Будут отображаться все колонки.', 'success');
    }

    getButton('ref-set-active-btn')!.onclick = async () => {
        const checked = Array.from(document.querySelectorAll<HTMLInputElement>('.ref-active-cb:checked')).map(cb => cb.dataset.fileId);
        await apiCall('/api/reference/set_active', 'POST', { file_ids: checked });
        showToast('Активные файлы обновлены', 'success');
        await loadGroups();
        await loadColumnSettings();
        await loadRefColumnCheckboxes();
    };

    // Закрытие модалки редактирования по клику вне окна или Escape
    getEl<HTMLElement>('ref-file-edit-modal')!.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).id === 'ref-file-edit-modal') {
            closeRefFileEditModal();
        }
    });
    getEl<HTMLElement>('ref-reprocess-modal')!.addEventListener('click', (e) => {
        if ((e.target as HTMLElement).id === 'ref-reprocess-modal') {
            closeRefReprocessModal();
        }
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const modal = getEl<HTMLElement>('ref-file-edit-modal')!;
            if (modal && modal.style.display === 'flex') {
                closeRefFileEditModal();
            }
            const repModal = getEl<HTMLElement>('ref-reprocess-modal')!;
            if (repModal && repModal.style.display === 'flex') {
                closeRefReprocessModal();
            }
        }
    });
    getButton('ref-column-load')!.onclick = loadRefColumnCheckboxes;
    getButton('ref-column-save')!.onclick = saveColumnSettings;
    getButton('ref-column-reset')!.onclick = resetColumnSettings;

    let pendingRefFile = null;
    let pendingRefTempId = null;
    let refUploadSuggested = null;
    let pendingRefPreview = [];
    let pendingRefColumns = [];
    let pendingRefSheets: string[] = [];
    let pendingRefSelectedSheets: string[] = [];

    function closeRefUploadModal(): void{
        getEl<HTMLElement>('ref-upload-modal')!.style.display = 'none';
        pendingRefFile = null;
        pendingRefTempId = null;
        refUploadSuggested = null;
        pendingRefPreview = [];
        pendingRefColumns = [];
        pendingRefSheets = [];
        pendingRefSelectedSheets = [];
        getEl<HTMLElement>('ref-upload-sheet-row')!.style.display = 'none';
        getEl<HTMLElement>('ref-upload-sheet-list')!.innerHTML = '';
    }
(window as any).closeRefUploadModal = closeRefUploadModal;

    function renderRefUploadPreview(): void{
        const container = getEl<HTMLElement>('ref-upload-preview')!;
        if (!pendingRefPreview.length) {
            container.innerHTML = '';
            return;
        }
        const hdrRow = parseInt(getInput('ref-upload-hdr')?.value || '0');
        let html = '<table style="font-size:11px; width:100%; border-collapse:collapse;">';
        pendingRefPreview.forEach((row, ridx) => {
            const isHeader = ridx === hdrRow;
            const bg = isHeader ? 'background:#d1ecf1; font-weight:bold;' : (ridx < hdrRow ? 'background:#f8f9fa; color:#666;' : '');
            html += `<tr style="${bg}"><td style="padding:2px 6px; border:1px solid #eee; white-space:nowrap; color:#888;">${ridx}</td>`;
            row.forEach(cell => {
                const display = String(cell).substring(0, 60);
                html += `<td style="padding:2px 6px; border:1px solid #eee; white-space:nowrap; max-width:200px; overflow:hidden; text-overflow:ellipsis;">${display}</td>`;
            });
            html += '</tr>';
        });
        html += '</table>';
        container.innerHTML = html;
    }
(window as any).renderRefUploadPreview = renderRefUploadPreview;

    function autoSelectRefColumns(): void{
        if (refUploadSuggested) {
            dualListInit('ref-upload-title-avail', 'ref-upload-title-sel', pendingRefColumns, [refUploadSuggested]);
        }
    }
(window as any).autoSelectRefColumns = autoSelectRefColumns;

    async function confirmRefUpload(): Promise<void>{
        if (!pendingRefFile || !pendingRefTempId) return;
        const titleColumns = dualListGetValues('ref-upload-title-sel');
        const fallback = getSelect('ref-upload-fallback')!.value || '';
        const excludeSel = getSelect('ref-upload-exclude')!;
        const excludeColumns = Array.from(excludeSel.selectedOptions).map(o => o.value).filter(v => v);

        const idColumn = getSelect('ref-upload-id')!.value || '';
        const territoryColumn = getSelect('ref-upload-territory')!.value || '';
        const qtyColumn = getSelect('ref-upload-qty')!.value || '';
        const qtyUnitColumn = getSelect('ref-upload-unit')!.value || '';
        const priceColumn = getSelect('ref-upload-price')!.value || '';
        const warehouseColumn = getSelect('ref-upload-wh')!.value || '';
        const contractNoColumn = getSelect('ref-upload-contract')!.value || '';
        const contractPosColumn = getSelect('ref-upload-contractpos')!.value || '';

        const formData = new FormData();
        formData.append('temp_id', pendingRefTempId);
        formData.append('title_columns', JSON.stringify(titleColumns));
        formData.append('fallback_column', fallback);
        formData.append('exclude_columns', JSON.stringify(excludeColumns));
        formData.append('id_column', idColumn);
        formData.append('territory_column', territoryColumn);
        formData.append('qty_column', qtyColumn);
        formData.append('qty_unit_column', qtyUnitColumn);
        formData.append('price_column', priceColumn);
        formData.append('warehouse_column', warehouseColumn);
        formData.append('contract_no_column', contractNoColumn);
        formData.append('contract_pos_column', contractPosColumn);
        formData.append('header_row', getInput('ref-upload-hdr')!.value || '0');
        if (pendingRefSelectedSheets && pendingRefSelectedSheets.length) {
            formData.append('sheet_names', JSON.stringify(pendingRefSelectedSheets));
        }

        showLoader('Обработка справочника...');
        const res = await apiCall('/api/reference/process_file', 'POST', formData, true);
        hideLoader();
        closeRefUploadModal();
        if (res && res.success) {
            await loadGroups();
            await loadReferenceFiles();
            showToast('Файл добавлен и обработан', 'success');
        }
    }
(window as any).confirmRefUpload = confirmRefUpload;

    function applyRefPreview(previewRes: any): void {
        const cols = previewRes?.columns || [];
        const setOpts = (id: string, val: any, multi = false) => {
            const sel = getSelect(id); if (!sel) return;
            if (multi) {
                sel.innerHTML = cols.map(c => `<option value="${c}">${c}</option>`).join('');
                if (val) {
                    Array.from(sel.options).forEach(opt => {
                        if (Array.isArray(val) ? val.includes(opt.value) : opt.value === val) {
                            opt.selected = true;
                        }
                    });
                }
            } else {
                sel.innerHTML = '<option value="">-- нет --</option>' + cols.map(c => `<option value="${c}" ${val === c ? 'selected' : ''}>${c}</option>`).join('');
            }
        };
        dualListInit('ref-upload-title-avail', 'ref-upload-title-sel', cols, refUploadSuggested ? [refUploadSuggested] : []);
        setOpts('ref-upload-fallback', '');
        setOpts('ref-upload-exclude', [], true);
        setOpts('ref-upload-wh', previewRes?.wh_column);
        setOpts('ref-upload-qty', previewRes?.qty_column);
        setOpts('ref-upload-unit', previewRes?.unit_column);
        setOpts('ref-upload-price', previewRes?.price_column);
        setOpts('ref-upload-territory', '');
        setOpts('ref-upload-contract', previewRes?.contract_column);
        setOpts('ref-upload-contractpos', previewRes?.contract_pos_column);
        setOpts('ref-upload-id', '');
        getInput('ref-upload-hdr')!.value = String(previewRes?.header_row || 0);
        pendingRefPreview = previewRes?.preview || [];
        pendingRefColumns = previewRes?.columns || [];
        renderRefUploadPreview();
    }

    function renderRefSheetCheckboxes(): void {
        const container = getEl<HTMLElement>('ref-upload-sheet-list');
        if (!container) return;
        container.innerHTML = pendingRefSheets.map(s => `
            <label style="display:flex; align-items:center; gap:4px; cursor:pointer;">
                <input type="checkbox" value="${s}" ${pendingRefSelectedSheets.includes(s) ? 'checked' : ''} data-action="onRefSheetToggle">
                ${s}
            </label>
        `).join('');
    }

    async function onRefSheetToggle(): Promise<void>{
        const checkboxes = document.querySelectorAll<HTMLInputElement>('#ref-upload-sheet-list input[type="checkbox"]:checked');
        const selected = Array.from(checkboxes).map(cb => cb.value);
        const prevFirst = pendingRefSelectedSheets[0];
        pendingRefSelectedSheets = selected;
        if (selected.length && selected[0] !== prevFirst && pendingRefFile) {
            const previewForm = new FormData();
            previewForm.append('file', pendingRefFile);
            previewForm.append('sheet_names', JSON.stringify(selected));
            showLoader('Загрузка листа...');
            const previewRes = await apiCall('/api/reference/upload_preview', 'POST', previewForm, true);
            hideLoader();
            if (!previewRes) return;
            pendingRefTempId = previewRes.temp_id;
            refUploadSuggested = previewRes.suggested_title_column;
            applyRefPreview(previewRes);
        }
    }
(window as any).onRefSheetToggle = onRefSheetToggle;

    getButton('ref-add-file')!.onclick = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv,.txt,.xlsx,.xls,.xlsb,.ods';
        input.onchange = async (e) => {
            const file = (e.target as HTMLInputElement).files?.[0];
            pendingRefFile = file;
            // Загружаем preview через новый endpoint
            const previewForm = new FormData();
            previewForm.append('file', file);
            showLoader('Определение колонок...');
            const previewRes = await apiCall('/api/reference/upload_preview', 'POST', previewForm, true);
            hideLoader();
            if (!previewRes) return;

            // Показываем модалку
            getEl<HTMLElement>('ref-upload-filename')!.innerText = file.name;
            pendingRefTempId = previewRes.temp_id;
            refUploadSuggested = previewRes.suggested_title_column;
            const cols = previewRes?.columns || [];

            // Обработка листов Excel
            if (previewRes.sheets && previewRes.sheets.length > 1) {
                pendingRefSheets = previewRes.sheets;
                pendingRefSelectedSheets = previewRes.selected_sheets || previewRes.sheets;
                renderRefSheetCheckboxes();
                getEl<HTMLElement>('ref-upload-sheet-row')!.style.display = 'block';
            } else {
                pendingRefSheets = [];
                pendingRefSelectedSheets = [];
                getEl<HTMLElement>('ref-upload-sheet-row')!.style.display = 'none';
                getEl<HTMLElement>('ref-upload-sheet-list')!.innerHTML = '';
            }

            applyRefPreview(previewRes);
            getEl<HTMLElement>('ref-upload-modal')!.style.display = 'flex';
        };
        input.click();
    };

    async function clearCache(target: string): Promise<void>{
        if (!confirm(`Очистить ${target === 'all' ? 'все данные кэша' : target}? Это действие нельзя отменить.`)) return;
        const res = await apiCall('/api/admin/clear_cache', 'POST', { target });
        if (res && res.success) {
            showToast(`Очищено: ${res.cleared.join(', ')}`, 'success');
        }
    }
(window as any).clearCache = clearCache;

    // -------------------- СТРАТЕГИИ (ОБРАБОТЧИКИ ИНТЕРФЕЙСА) --------------------
    getSelect('strat-group-select')!.onchange = () => renderStrategyEditor();
    getSelect('admin-attr-group-select')!.onchange = () => loadAdminAttrEditor();
    getSelect('strat-mode')!.onchange = async () => {
        const group = getSelect('strat-group-select')!.value;
        const mode = getSelect('strat-mode')!.value;
        if (mode !== 'custom') {
            if (currentUserRole === 'admin') {
                // Admin: show admin override if exists, otherwise load default preset
                const override = state.adminOverrides[group]?.[mode];
                if (!override) {
                    const res = await apiCall(`/api/strategies/preset/${group}/${mode}`, 'GET');
                    if (res && res.config) {
                        state.adminOverrides[group] = state.adminOverrides[group] || {};
                        state.adminOverrides[group][mode] = res.config;
                    }
                }
                renderStrategyEditor();
            } else {
                // Regular user: load preset into personal strategies
                const res = await apiCall(`/api/strategies/preset/${group}/${mode}`, 'GET');
                if (res && res.config) {
                    state.strategies[group] = { mode, config: res.config };
                    renderStrategyEditor();
                }
            }
        } else {
            if (!state.strategies[group]) state.strategies[group] = { mode: 'custom', config: {} };
            state.strategies[group].mode = 'custom';
            renderStrategyEditor();
        }
    };
    getButton('strat-save')!.onclick = saveCurrentStrategy;
    getButton('strat-reset-group')!.onclick = resetGroupStrategy;
    getButton('strat-reset-all')!.onclick = resetAllStrategies;
    getButton('use-default-strategies')!.onclick = loadDefaultStrategiesAndApply;

    // -------------------- ВЫБОР ГРУПП ДЛЯ МАССОВОГО ПОИСКА --------------------
    const massGroupsToggle = getButton('mass-search-groups-toggle')!;
    const massGroupsList = getEl<HTMLElement>('mass-search-groups-list')!;
    massGroupsToggle.onclick = (e) => {
        e.stopPropagation();
        massGroupsList.style.display = massGroupsList.style.display === 'none' ? 'block' : 'none';
    };
    document.addEventListener('click', (e) => {
        const dropdown = getEl<HTMLElement>('mass-search-groups-dropdown')!;
        if (dropdown && !dropdown.contains(e.target as Node)) {
            massGroupsList.style.display = 'none';
        }
    });
    massGroupsList.addEventListener('change', (e) => {
        if ((e.target as HTMLElement).tagName === 'INPUT' && (e.target as HTMLInputElement).type === 'checkbox') {
            updateMassGroupsToggleText();
        }
    });

    // -------------------- МЕНЮ СКАЧИВАНИЯ --------------------
    const dlMenuBtn = getButton('download-mass-menu-btn')!;
    const dlMenu = getEl<HTMLElement>('download-mass-menu')!;
    dlMenuBtn.onclick = (e) => {
        e.stopPropagation();
        dlMenu.style.display = dlMenu.style.display === 'none' ? 'block' : 'none';
    };
    document.addEventListener('click', (e) => {
        if (!dlMenu.contains(e.target as Node) && (e.target as Node) !== dlMenuBtn) {
            dlMenu.style.display = 'none';
        }
    });
    getButton('dl-confirm-btn')!.onclick = async () => {
        if (!state.massFileId) return;
        const format = document.querySelector<HTMLInputElement>('input[name=\"dl-format\"]:checked').value;
        const mode = document.querySelector<HTMLInputElement>('input[name=\"dl-mode\"]:checked').value;
        const includeNoAnalogs = getInput('dl-include-no-analogs')!.checked;
        await getMassColumns();
        // Для скачивания добавляем group/group_prod к выбранным колонкам
        let dlCols = (currentMassColumns || DEFAULT_MASS_COLUMNS).slice();
        if (!dlCols.includes('group')) dlCols.push('group');
        if (!dlCols.includes('group_prod')) dlCols.push('group_prod');
        const colParam = `&columns=${encodeURIComponent(JSON.stringify(dlCols))}`;
        window.location.href = `/api/mass_search_download/${state.massFileId}?format=${format}&mode=${mode}${colParam}`;
        if (includeNoAnalogs) {
            setTimeout(() => {
                window.location.href = `/api/mass_search_download_no_analogs/${state.massFileId}?format=${format}&mode=${mode}${colParam}`;
            }, 500);
        }
        dlMenu.style.display = 'none';
    };


